import { create } from 'zustand';
import { Invite, UserRole } from '../generated/gql-types';
import {
  fetchInvitesByUser,
  inviteUser as inviteUserAction,
} from './invite.action';

type InviteInput = {
  email: string;
  role: UserRole;
  clientId: string;
};

interface InviteState {
  invites: Invite[];
  setInvites: (invites: Invite[]) => void;
  fetchAllInvites: (userId: string) => void;
  fetchInvitesByUser: (userId: string) => void;
  inviteUser: (invite: InviteInput) => Promise<void>;
  isLoading: boolean;
}

export const useInviteStore = create<InviteState>((set) => ({
  //   state
  invites: [],
  isLoading: false,

  //   actions
  setInvites: (invites: Invite[]) => set({ invites }),

  //   mutations
  fetchAllInvites: async (userId: string) => {},
  fetchInvitesByUser: async (userId: string) => {
    try {
      set({ isLoading: true });
      const invites = await fetchInvitesByUser(userId);
      set({ invites });
    } catch (error) {
      console.error('Error fetching invites:', error);
    } finally {
      set({ isLoading: false });
    }
  },
  inviteUser: async (invite: InviteInput) => {
    try {
      set({ isLoading: true });
      await inviteUserAction(invite);
    } catch (error) {
      console.error('Error inviting user:', error);
    } finally {
      set({ isLoading: false });
    }
  },
}));
